export default __webpack_public_path__ + "static/3-25c8f4041cf4dd82675f0d94926fd9fa.png";